module.exports = __webpack_public_path__ + "img/open.6d2c2934.png";